import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  RTableConfig: {
    boxShadow: 'none',
    // '& > div': {
    //   minWidth: 1000
    // }
  },
  tableContainer: {
    margin: '25px 0 19px',
    padding: '20px 20px 0',
    borderRadius: 5,
    border: 'solid 1px #dadce0',
  },
}));
